import { Stack, useMediaQuery, useTheme } from '@mui/material';
import bannerKaigaiImage from 'assets/images/top/banner_kaigai.png';
import bannerRentalImage from 'assets/images/top/banner_rental.png';
import bannerPrepaidImage from 'assets/images/top/banner_prepaid.png';
import Carousel from 'react-material-ui-carousel';

const BannerSlider = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const bannerImages = [
    {
      src: bannerPrepaidImage,
      alt: 'プリペイド',
      url: 'https://www.wifi-tokyo-rentalshop.com/prepaid/?itm_source=lp&itm_medium=organic&itm_campaign=footer'
    },
    {
      src: bannerRentalImage,
      alt: 'レンタル',
      url: 'https://www.wifi-tokyo-rentalshop.com/pittariplan/'
    },
    {
      src: bannerKaigaiImage,
      alt: '海外WiFi',
      url: 'https://k-wifi.com/?itm_source=lp&itm_medium=organic&itm_campaign=new-services-k-banner'
    }
  ];

  return isMobile ? (
    // モバイルデバイスの場合はスライドショーを表示
    <Carousel>
      {bannerImages.map((image, index) => (
        <div key={index}>
          <a href={image.url}>
            <img src={image.src} alt={image.alt} style={{ width: '100%' }} />
          </a>
        </div>
      ))}
    </Carousel>
  ) : (
    // デスクトップ/タブレットの場合は横並びで表示
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}
    >
      {bannerImages.map((image, index) => (
        <a href={image.url} key={index}>
          <img src={image.src} alt={image.alt} style={{ width: '100%' }} />
        </a>
      ))}
    </Stack>
  );
};

export default BannerSlider;
